import React, { useEffect, useState } from 'react';
import PageHeader from "../../components/PageHeader";
import DataTable from "react-data-table-component";
import { customTableStyles, deleteConfirmation, loadingConfirmation, sweetAlert, sweetAlertConfirmation } from "../../utils";
import DriversEditModal from './EditModal';
import DriversAddModal from './AddModal';
import { Button } from "react-bootstrap";
import DriversViewodal from './ViewModal';
import { useGetDriverArchiveQuery, useGetDriverManageQuery, useRemoveDriverMutation, useResendInviteMutation, useUpdateManagementStatusMutation, useUpdateStatusMutation } from '../../redux/services/DriverService';
import CustomPagination from '../../components/CustomPagination';
import useLiveDataTable from '../../hooks/useLiveDataTable';
import { Link, useNavigate } from 'react-router-dom';
import DriverViewSide from './DriverSideView';
import MenuComponent from '../../components/MenuComponent';

const DriverManagementArchivePage = () => {
    const navigate = useNavigate()
    const {
        currentPage,
        perPage,
        q,
        searchQuery,
        setSearchQuery,
        handlePageChange,
        handlePerPageChange,
        handleSearchChange,
        onSearchKeyHandler,
        handleSearchBy,
        searchBy,
    } = useLiveDataTable();

    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(null)
    const [isView, setIsView] = useState(false)

    const [removeRequest] = useRemoveDriverMutation()
    const [inviteRequest] = useResendInviteMutation()

    const [updateStatus, { isLoading: isLoadinStatus }] = useUpdateManagementStatusMutation()

    const { data: data2, isLoading, isFetching, refetch } = useGetDriverArchiveQuery(`?page=${currentPage}&perPage=${perPage}&column=${searchBy}&search=${q}`)
    const drivers = data2?.response?.data?.data
    const archives = data2?.response?.data?.data
    const total = data2?.response?.data?.total;

    useEffect(() => {
        refetch()
    }, [])

    const handleView = (item) => {
        setIsEdit(item)
        setIsView(true)
    }
    const handleEdit = (item) => {
        setIsEdit(item)
        setIsShow(true)
    }
    const handleAdd = () => {
        setIsEdit(null)
        setIsShow(true)
        // reset()
    }
    const expiryColor = (date, currentDate) => {
        let expiryDate = new Date(date);
        let diff = expiryDate - currentDate;
        let days = Math.floor(diff / (1000 * 60 * 60 * 24));

        switch (true) {
            case (days < 0):
                return <span className='badge bg-danger rounded-2 px-2'>{date}</span>;

            case (days >= 30):
                return <span className='badge bg-success rounded-2 px-2'>{date}</span>;

            case (days < 30 && days >= 21):
                return <span className='badge bg-info rounded-2 px-2'>{date}</span>;

            case (days < 21 && days >= 10):
                return <span className='badge bg-warning rounded-2 px-2'>{date}</span>;

            case (days < 10):
                return <span className='badge bg-danger rounded-2 px-2'>{date}</span>;

            default:
                return null; // Fallback case, if needed
        }
    };

    const statusColor = (status) => {
        switch (status) {
            case 0:
                return '#44b86c'
            case 1:
                return '#e82646'
            case 2:
                return '#f7b725'
            case 3:
                return '#17b1df'
            case 4:
                return '#17b1df'
            default:
                return 'black'
        }
    }


    const handleRemove = async (item) => {
        sweetAlertConfirmation()
            .then(async (result) => {
                if (result.isConfirmed) {
                    await removeRequest(item?.id)
                        .unwrap()
                        .then((res) => {
                            if (res?.status) {
                                sweetAlert(res?.message, 'success')
                                refetch()
                            }
                        })
                        .catch((err) => {
                            sweetAlert(err?.data?.message, 'error')
                        })
                }
            })
    }

    console.clear();
    console.log(drivers);

    console.log(archives);

    return (
        <>
            <PageHeader name="Archive Drivers" />
            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0">
                                    <div className="col-auto p-0 d-flex ms-2">
                                        <Button
                                            className="btn btn-primary"
                                            onClick={() => refetch()}
                                        >
                                            Refresh
                                        </Button>
                                    </div>
                                    <div className="col-auto ms-auto">
                                        <button className="btn bg-light text-capitalize">
                                            Search By: <span className='text-success'>{searchBy?.split('_')?.join(' ')?.replace('full name', 'driver name')}</span>
                                        </button>
                                    </div>
                                    <div className="col-lg-3 col-5 p-0 ">
                                        <div className="input-group m-0">
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                                value={searchQuery}
                                                onKeyUp={(e) => onSearchKeyHandler(e)}
                                                onChange={(e) => setSearchQuery(e.target?.value)}
                                            />
                                            <span
                                                type="button"
                                                onClick={() => handleSearchChange(searchQuery)}
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line" />
                                            </span>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <CustomPagination
                                    isFetching={isFetching}
                                    data={archives}
                                    total={total}
                                    onChangePage={handlePageChange} // Handle page change
                                    onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                                    paginationDefaultPage={currentPage} // Set the current page

                                    columns={[
                                        {
                                            name: 'ID',
                                            selector: row => row?.id,
                                            sortable: true,
                                            width: '70px'
                                        },
                                        {
                                            selector: row => row.full_name,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('full_name')}
                                                >
                                                    {searchBy == 'full_name' ? <b className='text-success'>Driver Name</b> : 'Driver Name'}
                                                </span>
                                            )
                                        },
                                        {
                                            selector: row => row.email,
                                            sortable: true,
                                            name: (
                                                <span
                                                    onClick={() => handleSearchBy('email')}
                                                >
                                                    {searchBy == 'email' ? <b className='text-success'>Email</b> : 'Email'}
                                                </span>
                                            )
                                        },
                                        {
                                            name: 'Phone Number',
                                            selector: row => row.phone,
                                            sortable: true,
                                        },
                                        {
                                            name: 'License Expiry',
                                            selector: row => expiryColor(row.expiration_date, new Date()),
                                            sortable: true,
                                            width: '150px'
                                        },
                                        {
                                            name: 'MVR Expiraty',
                                            selector: row => expiryColor(row.mvr_expiration_date, new Date()),
                                            sortable: true,
                                        },
                                        {
                                            name: 'Medical Expiry',
                                            selector: row => expiryColor(row.exp_medical_examiner_date, new Date()),
                                            sortable: true,
                                        },
                                        {
                                            name: 'Date of Last Drug Test',
                                            selector: row => expiryColor(row.last_drug_test, new Date()),
                                            sortable: true,
                                        },
                                        {
                                            name: 'Employment Status',
                                            selector: row => (
                                                <>
                                                    {/* { title: 'Pending', id: 0 }, { title: 'Submitted', id: 1 }, */}
                                                    <MenuComponent
                                                        data={[{ title: 'Active', id: 0 }, { title: 'Terminated', id: 1 }, { title: 'Leave', id: 2 }]}
                                                        selectedData={row?.status?.title ? row?.status?.title : 'Select Status'}
                                                        selectdId={row?.employment_status}
                                                        color={statusColor(parseInt(row?.employment_status)) || 'black'}
                                                        update={updateStatus}
                                                        title={'Select Drive Management Status'}
                                                        isLoading={isLoadinStatus}
                                                        id={row?.id}
                                                        updateKey={'status'}
                                                    // refetch={refetch}
                                                    />
                                                </>
                                            ),
                                            sortable: true,
                                        },
                                        {
                                            name: 'Document Status',
                                            selector: row => row.document_status == 3 && <span className='badge bg-primary py-1 rounded-2 px-2'>Approved</span>,
                                            sortable: true,
                                        },

                                        {
                                            name: 'Date Created',
                                            selector: row => row.created_at,
                                            sortable: true,
                                        },
                                        {
                                            name: 'Actions',
                                            cell: (row, i) => {
                                                return (
                                                    <>
                                                        <div className="hstack gap-1 fs-1">
                                                            <button
                                                                aria-label="view"
                                                                onClick={() => loadingConfirmation(() => inviteRequest(row?.id), 'Inviting')}
                                                                className="btn btn-sm btn-primary-light btn-wave waves-effect waves-light"
                                                            >
                                                                Resend Invite
                                                            </button>
                                                            <Link
                                                                to={`/drivers/view/${row?.id}`}
                                                                state={{ alert: false }}
                                                                aria-label="View"
                                                                // onClick={() => handleView(row)}
                                                                className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                                            >
                                                                <i className="ri-eye-line" />
                                                            </Link>
                                                            <button
                                                                aria-label="edit"
                                                                onClick={() => navigate(`/driver-aaplication/edit/${row?.id}`, { state: { isEdit: row } })}
                                                                className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                                            >
                                                                <i className="ri-edit-line" />
                                                            </button>
                                                            <a
                                                                aria-label="anchor"
                                                                onClick={() => deleteConfirmation(() => removeRequest(row?.id))}
                                                                className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                                                            >
                                                                <i className="ri-delete-bin-7-line" />
                                                            </a>
                                                        </div>
                                                    </>
                                                )
                                            },
                                            ignoreRowClick: true,
                                            allowOverflow: true,
                                            button: true,
                                            width: '220px'
                                        },
                                    ]}

                                />
                                {/* <DataTable
                                    paginationServer // Enable server-side pagination
                                    paginationTotalRows={total} // Total number of rows in the table
                                    onChangePage={handlePageChange} // Handle page change
                                    onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                                    paginationDefaultPage={currentPage} // Set the current page


                                    columns={columns}
                                    data={drivers}
                                    customStyles={customTableStyles}
                                    pagination={true}
                                    progressPending={isFetching}
                                    progressComponent={<>
                                        <span className="loading d-flex align-items-center justify-content-center"
                                            style={{ height: 200 }}>
                                            <i className="ri-loader-2-fill fs-25 rotation"></i>
                                        </span>
                                    </>}
                                /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {isShow && (
                <DriversAddModal
                    show={isShow}
                    handleClose={() => setIsShow(false)}
                    isEdit={isEdit}
                />
            )}

            {/* <DriversEditModal
                show={isEdit}
                handleClose={() => setIsEdit(false)}
            /> */}
            {isView && (
                <DriversViewodal
                    show={isView}
                    handleClose={() => setIsView(false)}
                    isEdit={isEdit}
                />
            )}

            {/* <DriverViewSide
                show={isView}
                close={() => setIsView(false)}
            /> */}
        </>
    );
};

export default DriverManagementArchivePage;